export interface ConferenceEvent {
    day: string;
    nid: number;
    room: string;
    speaker: string;
    time: string;
    title: string;
    track: string;
    type: string;
    hidden: boolean;
    favorited?: boolean;
    speakers?: Speaker[];
    floor_map: Img;

    additional_notes?: string;
    day_of_week: string;
    event_type: string;
    event_type_value: string;
    field_event_livestreamed?: number;
    field_event_notes?: string;
    field_event_notes_button?: string;
    itinerary_contact?: string;
    linked_itinerary?: string
    number_traveling?: string;
    speaking_location?: string;
    status: boolean;

    // Taxonomy Term Relationship
    tid?: number;
    name?: string;
    description?: string;
    field_location_image?: string;

  }

  export interface Speaker {
    nid: number;
    promote: string;
    speaker_photo?: Img;
    status: string;
    title: string;
  }

  export interface Img {
    alt?: string;
    src?: string;
    title?: string;
  }

  export class SessionGroup {
    day_of_week: string;
    day: string;
    events: ConferenceEvent[];
    time?: string;
    hidden: boolean;
    events_by_time?: SessionGroupTimes[] = [];
    constructor(dayOfWeek: string, day: string, events: ConferenceEvent[], hidden: boolean, time?: string,) {
      this.day_of_week = dayOfWeek;
      this.day = day;
      this.time = time;
      this.events = events;
      this.hidden = hidden;
    }
  }

  export class SessionGroupTimes {
    time: string;
    events: ConferenceEvent[];
    constructor(time: string, events: ConferenceEvent[] = []) {
      this.time = time;
      this.events = events;
    }
  }

  export class SpeakerGroup {
    category: string;
    speakers: Speaker[];
    qid?: number;
    hidden: boolean;
    constructor(category: string, speakers: any[], qid: number, hidden: boolean) {
      this.category = category;
      this.speakers = speakers;
      this.qid = qid;
      this.hidden = hidden;
    }
  }
  export interface Speaker {
    title: string;
    last_name: string;
    image: string;
    location: string;
    speaker_title: string;
    category: any;
    hidden: boolean;
    nid: number;
    field_speaker_category: any;
    position: number;
    qid: number;
    queue_title: string;
  }

